module.exports = __webpack_public_path__ + "static/media/unemployment.bab28e16.gif";